/**
 * @generated SignedSource<<d24401e947f6f2781b9f949f64448d31>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type TaskSentiment = "NEGATIVE" | "NEUTRAL" | "POSITIVE";
import { FragmentRefs } from "relay-runtime";
export type WidgetTaskSingleCheckSmallInProgress_taskExecutions$data = ReadonlyArray<{
  readonly checkValue: TaskSentiment | null;
  readonly " $fragmentSpreads": FragmentRefs<"taskExecutionListCombineCheckTaskExecutions">;
  readonly " $fragmentType": "WidgetTaskSingleCheckSmallInProgress_taskExecutions";
}>;
export type WidgetTaskSingleCheckSmallInProgress_taskExecutions$key = ReadonlyArray<{
  readonly " $data"?: WidgetTaskSingleCheckSmallInProgress_taskExecutions$data;
  readonly " $fragmentSpreads": FragmentRefs<"WidgetTaskSingleCheckSmallInProgress_taskExecutions">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "WidgetTaskSingleCheckSmallInProgress_taskExecutions",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "checkValue",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "taskExecutionListCombineCheckTaskExecutions"
    }
  ],
  "type": "TaskExecutionCheck",
  "abstractKey": null
};

(node as any).hash = "99df23e4b58a3df0053c6d00754bf2ef";

export default node;
